export default __webpack_public_path__ + "static/media/Home-southern.d0a011d2.png";